import type { JTLDescription } from '@/lib/api/descriptions'

export const MASTER_CHANNEL_ID = '1-1-0'

export const CONTENT_FIELDS = [
  'Name', 'ShortDescription', 'Description',
  'SeoTitleTag', 'SeoMetaDescription', 'SeoMetaKeywords', 'SeoPath',
] as const

export type ContentFieldKey = (typeof CONTENT_FIELDS)[number]

export const BULLET_KEYS = ['Bullet1', 'Bullet2', 'Bullet3', 'Bullet4', 'Bullet5'] as const
export type BulletKey = (typeof BULLET_KEYS)[number]

export function bulletKeyToApiKey(
  key: BulletKey,
): 'bullet_1' | 'bullet_2' | 'bullet_3' | 'bullet_4' | 'bullet_5' {
  const n = key.slice(-1)
  return `bullet_${n}` as 'bullet_1' | 'bullet_2' | 'bullet_3' | 'bullet_4' | 'bullet_5'
}

export const CHANNEL_NAMES: Record<string, string> = {
  '1-1-0': 'JTL-Wawi',
  '1-1-1': 'Alle Kanäle',
  '2-1-0': 'Onlineshop',
  '5-30-0': 'eBay',
  '6-50-0': 'Amazon',
  '6-51-0': 'Amazon.de',
  '6-52-0': 'Amazon.co.uk',
  '6-53-0': 'Amazon.fr',
  '6-54-0': 'Amazon.it',
  '6-55-0': 'Amazon.es',
  '6-56-0': 'Amazon.nl',
  '6-59-0': 'Amazon.com',
  '6-70-0': 'OTTO',
  '6-80-0': 'Kaufland',
  '7-1-0': 'JTL-POS',
  '9-1-0': 'REST API',
}

export const LANGUAGE_LABELS: Record<string, string> = {
  ger: 'DE', eng: 'EN', fre: 'FR', ita: 'IT', spa: 'ES',
  nld: 'NL', pol: 'PL', de: 'DE', en: 'EN', fr: 'FR',
}

export const FIELD_LABELS: Record<ContentFieldKey, string> = {
  Name: 'productContent.channels.name',
  ShortDescription: 'productContent.channels.shortDescription',
  Description: 'productContent.channels.description',
  SeoTitleTag: 'productContent.channels.seoTitle',
  SeoMetaDescription: 'productContent.channels.seoMetaDescription',
  SeoMetaKeywords: 'productContent.channels.seoMetaKeywords',
  SeoPath: 'productContent.channels.seoPath',
}

/** Whether a field should render as a multiline textarea */
export const MULTILINE_FIELDS: Set<ContentFieldKey> = new Set([
  'Description', 'ShortDescription', 'SeoMetaDescription',
])

/** Normalize channel ID: "6-50" → "6-50-0" */
function normalizeChannelId(id: string): string {
  const parts = id.split('-')
  if (parts.length === 2) return `${id}-0`
  return id
}

export function getChannelName(id: string): string {
  return CHANNEL_NAMES[id] ?? CHANNEL_NAMES[normalizeChannelId(id)] ?? `Kanal ${id}`
}

export function getFieldValue(desc: JTLDescription | undefined, field: ContentFieldKey): string {
  return desc?.[field] ?? ''
}
